<template>
    <div class="homemall">
        <el-row class="mt20 mb20 fr ac" v-if="goods_type || industry_uuid || active_class.length">
            <el-col :span="3" class="fr ac jc">
                <p class="fz14">已选分类</p>
            </el-col>
            <el-col :span="21">
                <el-row class="fr ac">
                    <el-col :span="21" class="fr ac fw">
                        <p class="active_class" v-if="goods_type">
                            <span>{{goods}}</span>
                            <i class="el-icon-close cursor" @click="goods_type = null" />
                        </p>
                        <p class="active_class" v-if="industry_uuid">
                            <span>{{industry_name}}</span>
                            <i class="el-icon-close cursor" @click="industry_uuid = null" />
                        </p>
                        <p class="active_class" v-for="(i,k) in active_class" :key="i.uuid">
                            <span>{{i.name}}</span>
                            <i
                                class="el-icon-close cursor"
                                @click="class_uuidselect(i.uuid, i.name)"
                            />
                        </p>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
        <div class="header">
            <!-- 商品分类 -->
            <el-row>
                <el-col :span="3">
                    <p class="title">商品分类</p>
                </el-col>
                <el-col :span="21" class="bb1 pb20">
                    <el-row class="fr ac">
                        <el-col :span="21" class="fr ac fw">
                            <p
                                class="fz14 black content cursor mr20"
                                :class="{black:goods_type != i.type,blue:goods_type == i.type}"
                                v-for="i in shop_nav"
                                :key="i.type"
                                @click="goods_type = i.type"
                            >{{i.name}}</p>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
            <!-- 行业分类 -->
            <el-row>
                <el-col :span="3">
                    <p class="title">行业分类</p>
                </el-col>
                <el-col :span="21" class="bb1 pb20">
                    <el-row class="fr ac">
                        <el-col :span="21" class="fr ac fw">
                            <p
                                class="fz14 black content cursor mr20"
                                :class="{black:industry_uuid != i.uuid,blue:industry_uuid == i.uuid}"
                                v-for="i in recommand_industry"
                                :key="i.uuid"
                                @click="industry_uuid = i.uuid,industry_name = i.industry_name"
                            >{{i.industry_name}}</p>
                        </el-col>
                        <el-col :span="3" class="fr ac jc">
                            <div class="more cursor">
                                <span class="fz14 white">更多</span>
                                <i class="el-icon-arrow-up fz14 white"></i>
                            </div>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
            <!-- 类型分类 -->
            <el-row>
                <el-col :span="3" class="pt20">
                    <p class="title">类型分类</p>
                </el-col>
                <el-col :span="21" class="pt20">
                    <el-row>
                        <el-col :span="21" class="fr ac jsa fw cursor">
                            <p
                                class="fz14 black content"
                                v-for="i in recommand_class"
                                :key="i.class_id"
                                @click="class_uuidselect(i.uuid,i.class_name)"
                                :class="{black:class_uuid.indexOf(i.uuid) == -1,blue:class_uuid.indexOf(i.uuid) != -1}"
                            >{{i.class_name}}</p>
                        </el-col>
                        <el-col :span="3" class="fr ac jc">
                            <div class="more cursor">
                                <span class="fz14 white">更多</span>
                                <i class="el-icon-arrow-up fz14 white"></i>
                            </div>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </div>
        <div class="filter fr ac fz14">
            <div class="fr ac mr20 cursor" @click="sales = !sales">
                <span :class="{black:!sales,blue:sales}">销量</span>
                <i class="el-icon-caret-top blue" v-if="sales" />
                <i class="el-icon-caret-bottom black" v-else />
            </div>
            <div class="fr ac mr20 cursor" @click="praise = !praise">
                <span :class="{black:!praise,blue:praise}">最多人选用</span>
                <i class="el-icon-caret-top blue" v-if="praise" />
                <i class="el-icon-caret-bottom black" v-else />
            </div>
            <div class="fr ac mr20 cursor" @click="price = !price">
                <span :class="{black:!price,blue:price}">价格</span>
                <i class="el-icon-caret-top blue" v-if="price" />
                <i class="el-icon-caret-bottom black" v-else />
            </div>
            <div class="fr ac">
                <div class="price_box">
                    <input type="Number" v-model="goods_min_price" />
                </div>
                <hr class="hr" />
                <div class="price_box mr10">
                    <input type="Number" v-model="goods_max_price " />
                </div>
                <el-button type="primary" size="mini" @click="getgoodslist">确认</el-button>
            </div>
        </div>
        <div class="main mt20">
            <el-row class="fr afs">
                <el-col :span="18" class="fr fw ac jsb pl20 pt20 pr20 bg_white">
                    <goods-cell v-for="(i,k) in goods_list" :key="i.goods_id" :goods="i" />
                    <div class="test" v-for="i in 4-(goods_list.length %4)"></div>
                </el-col>
                <el-col :span="6" class="bg_white ml20 pl20 pr20 pt20">
                    <p class="fz12 bold black mb10">推荐商品</p>
                    <col-cell v-for="(i,k) in recommand_list" :key="i.goods_id" :goods="i" />
                </el-col>
            </el-row>
        </div>
        <!-- 底部分页 -->
        <div class="footer fr ac jc">
            <el-pagination
                small
                :hide-on-single-page="true"
                layout="prev, pager, next"
                :total="total"
                :current-page.sync="currentPage"
                :page-size="pageSize"
                background
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import GoodsCell from "@/components/GoodsCell";
import ColCell from "@/components/ColCell";
export default {
    data() {
        return {
            industry_name: "",
            shop_nav: [
                {
                    name: "定制商品",
                    type: "1"
                },
                {
                    name: "标准商品",
                    type: "2"
                },
                {
                    name: "配件及维修设备",
                    type: "3"
                }
            ],
            recommand_list: [], //推荐的商品
            recommand_industry: [], //行业分类
            recommand_class: [], //类型分类
            goods_list: [],
            currentPage: 1,
            industry_uuid: null, //行业筛选ID
            class_uuid: [], //类型分类筛选ID
            sort: null, //排序
            goods_min_price: null, //最低价格
            goods_max_price: null, //最高价格
            total: null, //总数量
            pageSize: 20, //每页数量
            sales: false, //销量
            praise: false, //最多人选用
            price: false, //价格
            type: null,
            goods_type: null,
            active_class: []
        };
    },
    computed: {
        goods() {
            if (this.goods_type == "1") {
                return "定制商品";
            } else if (this.goods_type == "2") {
                return "标准商品";
            } else if (this.goods_type == "3") {
                return "配件及维修设备";
            } else {
                return "";
            }
        }
    },
    created() {
        this.type = this.$route.query.type;
        this.goods_type = this.$route.query.goods_type || null;
        this.getRecommandIndustry();
        this.getRecommandClass();
        this.getgoodslist();
        this.goodslist();
    },
    watch: {
        currentPage(n) {
            this.getgoodslist(n);
        },
        industry_uuid(n) {
            this.getgoodslist();
        },
        goods_type(n) {
            this.getgoodslist();
        },
        sales(n) {
            if (n) {
                this.price = false;
                this.praise = false;
            }
            this.getgoodslist();
        },
        price(n) {
            if (n) {
                this.sales = false;
                this.praise = false;
            }
            this.getgoodslist();
        },
        praise(n) {
            if (n) {
                this.price = false;
                this.sales = false;
            }
            this.getgoodslist();
        },
        $route(n) {
            this.getgoodslist();
        }
    },
    methods: {
        // 类型分类选中或者取消选中。
        class_uuidselect(id, name) {
            // 如果class_uuid里面没有，表示未选择，需要选中
            if (this.class_uuid.indexOf(id) == -1) {
                this.class_uuid.push(id);
                this.active_class.push({
                    uuid: id,
                    name: name
                });
                // 如果有，表示已选择，需要取消选中。
            } else if (this.class_uuid.indexOf(id) != -1) {
                this.class_uuid.splice(this.class_uuid.indexOf(id), 1);
                let index = null;
                this.active_class.some((el, i) => {
                    if (id == el.uuid) {
                        index = i;
                    }
                });
                this.active_class.splice(index, 1);
            }
            this.getgoodslist();
        },
        // 获取行业分类
        getRecommandIndustry() {
            this.post("goodsInterfaces/v1.0/getRecommandIndustry").then(res => {
                this.recommand_industry = res.data;
            });
        },
        // 获取类型分类
        getRecommandClass() {
            this.post("goodsInterfaces/v1.0/getRecommandClass").then(res => {
                this.recommand_class = res.data;
            });
        },
        // 获取商品列表
        getgoodslist() {
            let obj = {};
            obj.page = this.currentPage;
            // 行业分类
            if (this.industry_uuid) {
                this.type = null;
                obj.industry_uuid = this.industry_uuid;
            }
            // 类型分类
            if (this.class_uuid.length) {
                this.type = null;
                obj.class_uuid = this.class_uuid.join(",");
            }
            obj.goods_type = this.goods_type || "";
            // 商品名称。
            if (this.$route.query.goods_name) {
                obj.goods_name = this.$route.query.goods_name;
            }
            if (this.type) {
                if (this.type == 1) {
                    obj.is_recommend = 1;
                    obj.type = 1;
                } else if (this.type == 2) {
                    obj.is_promote = 1;
                    obj.type = 2;
                } else if (this.type == 3) {
                    obj.goods_type = 3;
                    obj.type = 3;
                }
            }
            // 排序
            if (this.sales) obj.sort = "sales_asc";
            if (this.price) obj.sort = "price_asc";
            if (this.praise) obj.sort = "assessment_asc";
            if (this.goods_min_price)
                obj.goods_min_price = this.goods_min_price;
            if (this.goods_max_price)
                obj.goods_max_price = this.goods_max_price;
            obj.pageSize = this.pageSize;
            this.post("goodsInterfaces/v1.0/getGoodsList", obj).then(res => {
                this.goods_list = res.data;
                this.total = res.total;
            });
        },
        // 获取推荐的商品
        goodslist() {
            this.post("goodsInterfaces/v1.0/getGoodsList", {
                page: 1,
                type: 1
            }).then(res => {
                this.recommand_list = res.data;
            });
        }
    },
    components: { "goods-cell": GoodsCell, "col-cell": ColCell }
};
</script>

<style  lang="scss">
.homemall {
    .test {
        width: 205px;
        height: 280px;
    }
    width: 1200px;
    margin: 0 auto;
    padding: 20px 0;
    .active_class {
        padding: 5px 10px;
        border: 1px solid rgba(15, 126, 251, 1);
        font-size: 12px;
        color: rgba(15, 126, 251, 1);
        margin-right: 20px;
        margin-bottom: 10px;
    }
    .header {
        width: 100%;
        padding: 20px;
        background-color: #fff;
        .title {
            width: 100px;
            height: 30px;
            text-align: center;
            line-height: 30px;
            background: rgba(239, 239, 239, 1);
            font-size: 14px;
        }
        .content {
            line-height: 30px;
            &:hover {
                color: #4990f3;
            }
        }
        .more {
            width: 60px;
            height: 30px;
            background: rgba(69, 142, 246, 1);
            line-height: 30px;
            text-align: center;
        }
    }
    .filter {
        margin-top: 20px;
        width: 1200px;
        height: 50px;
        padding: 0 20px;
        background: rgba(255, 255, 255, 1);
        .price_box {
            width: 70px;
            height: 30px;
            border: 1px solid rgba(151, 151, 151, 1);
            opacity: 1;
            input {
                width: 100%;
                height: 100%;
                padding-left: 10px;
            }
        }
        .hr {
            width: 20px;
        }
    }
    .main {
        width: 100%;
        // background-color: #fff;
    }
    .footer {
        width: 100%;
        height: 100px;
        .el-pagination {
            .el-pager {
                .number {
                    border: 1px solid #979797;
                }
                .active {
                    border: none !important;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/page/homePage/homeMall/index.vue